"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Link = _interopRequireDefault(require("../Link"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// import Button from 'cccisd-click-button';
// import { HashLink } from 'react-router-hash-link';
/**
 * settings: {
 *      links: [
 *          {
 *              "text": "sometext"
 *              "isButton": true,
 *              "buttonClassName": "",
 *              "openBlank": true,
 *              "path": "/dashboard/clients/{id}",
 *              "pathVars": {
 *                  "id": {
 *                      "isStatic": false
 *                      dataPath: "row.id"
 *                  },
 *                  "value": {
 *                      "isStatic": true,
 *                      "value": 'foobar'
 *                  }
 *              },
 *          }
 *      ]
 *   },
 * }
 */
var _default = exports["default"] = function _default(settings) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row,
      loadData = _ref.loadData;
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex'
      },
      className: (0, _classnames["default"])('table-renderers-link-many', 'text-nowrap')
    }, settings.links.map(function (link, i) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: i,
        style: {
          marginRight: '10px'
        }
      }, (0, _Link["default"])(link)({
        value: value,
        row: row,
        loadData: loadData
      }));
    }));
  };
};